import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { promiseTouchedByModel, gluerUniqueFlagKey, gluerUniqueFlagValue } from './core/constants';
import runtimeVar from './core/runtimeVar';
export var getType = function getType(arg) {
  return Object.prototype.toString.call(arg);
};
export var isPlainObject = function isPlainObject(target) {
  return getType(target) === '[object Object]';
};
export var isPromise = function isPromise(target) {
  return getType(target) === '[object Promise]';
};
export var isAsync = function isAsync(target) {
  var type = getType(target);
  return type === '[object AsyncFunction]' || type === '[object Promise]';
};
export var isArray = function isArray(target) {
  return getType(target) === '[object Array]';
};
export var tagPromise = function tagPromise(p) {
  Object.defineProperty(p, promiseTouchedByModel, {
    value: true,
    writable: false,
    configurable: false,
    enumerable: false
  });
};
export var isTagged = function isTagged(p) {
  return p[promiseTouchedByModel];
};
export var isModel = function isModel(model) {
  if (!model) return false;
  return model[gluerUniqueFlagKey] === gluerUniqueFlagValue;
};
export var composeReducer = function composeReducer() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  if (args.length === 0) {
    throw new Error('composeReducer needs at least 1 param, but got 0');
  }
  return args.reduce(function (pre, cur, currentIndex) {
    if (!currentIndex) {
      return pre;
    }
    return function (state, data) {
      var beforeState = pre(state, data);
      if (isAsync(beforeState)) {
        var runtimeFromDerived = runtimeVar.runtimeFromDerived;
        return beforeState.then(function (s) {
          runtimeVar.runtimeFromDerived = runtimeFromDerived;
          return cur(s, data);
        });
      }
      return cur(beforeState, data);
    };
  }, args[0]);
};
export var mergeCurToPre = function mergeCurToPre(arr) {
  return (arr || []).reduce(function (pre, cur) {
    if (isPlainObject(pre) && isPlainObject(cur) && !Object.is(pre, cur)) {
      return _objectSpread(_objectSpread({}, pre), cur);
    }
    return cur;
  }, {});
};
export var isDevelopment = function isDevelopment() {
  return process.env.NODE_ENV === 'development';
};